import {initializeQuantityInput} from "./QuickBuy";

export default () => {
    const product = document.querySelector('.customProductPage');
    if(!product) return;

    const productATCBar = product.querySelector('.customProductPage__add-to-cart');
    const productForm = product.querySelector('form.cart');
    if(!productATCBar || !productForm) return;
    window.addEventListener("DOMContentLoaded", function() {
        const addToCartObserver = new IntersectionObserver((entries) => {
            if(!entries[0].isIntersecting) {
                productATCBar.classList.add('customProductPage__add-to-cart--visible');
            } else{
                productATCBar.classList.remove('customProductPage__add-to-cart--visible');
            }
        }, {
            rootMargin: '-100px 0px 0px 0px'
        });
        addToCartObserver.observe(productForm);

        initializeProductATCQuantity();
        initializeProductATCButton(productATCBar);
        initializeProductATCAttributes(productATCBar);
    }, false);
}

const initializeProductATCQuantity = () => {
    initializeQuantityInput(document.querySelector('.customProductPage__add-to-cart .quantity'));
}

const initializeProductATCButton = (wrapper) => {
    const form = document.querySelector('.customProductPage__summary form');
    const addToCartButton = wrapper.querySelector('.single_add_to_cart_button');
    const mainAddToCartButton = document.querySelector('.customProductPage__summary form .single_add_to_cart_button');

    if(!form || !addToCartButton || !mainAddToCartButton) return;
    addToCartButton.addEventListener('click', async e => {
        e.preventDefault();
        e.stopPropagation();
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        mainAddToCartButton.click();
    });

    document.addEventListener('adding_to_cart', (event) => {
        addToCartButton.classList.add('loading');
    })
    document.addEventListener('failed_adding_to_cart', (event) => {
        addToCartButton.classList.remove('loading');
    })
    jQuery(document.body).on('added_to_cart', (event) => {
        addToCartButton.classList.remove('loading');
    });

    jQuery(form).on('found_variation', (event, variation) => {
        const priceElement = addToCartButton.querySelector(':scope > span');
        if(priceElement === null) return;
        const price = () => {
            let div = document.createElement('div');
            div.innerHTML = variation.price_html;
            if(!div.firstChild) return '';
            div.firstChild.classList.remove('price');
            return div.firstChild;
        }
        priceElement.replaceWith(price());
    });
}

const initializeProductATCAttributes = (wrapper) => {
    const form = document.querySelector('.customProductPage__summary form');
    const selects = wrapper.querySelectorAll('select');
    if(selects.length === 0 || !form) return;

    selects.forEach(select => {
        select.addEventListener('change', e => {
            e.preventDefault();
            const attribute = form.querySelector(`select[name="${select.getAttribute('data-attribute_name')}"]`);
            if(!attribute) return;

            attribute.value = select.value;
            jQuery('form.variations_form')
                .trigger('woocommerce_variation_select_change')
                .trigger('check_variations')
                .trigger('woocommerce_variation_has_changed');
        })
    })

    jQuery(form).on('found_variation', (event, variation) => {
        for (const [key, value] of Object.entries(variation.attributes)) {
            const select = wrapper.querySelector(`select[name="${key}"]`);
            if(!select || select.value === value) continue;
            select.value = value;
        }
    });
}